import {regenBasic} from "../utils/axios";
import {getHasImpersonate, getUserId, parseJwt} from "../utils/jwt";
import getDeviceId from "../utils/deivceId";

const deviceId = getDeviceId();

//Cart
export const getCart = async (showTaxes = false, returnToCart = false) => {
  const userId = getUserId() || deviceId;
  if (!userId) {
    return [];
  }
  let url = userId ? `/cart/${userId}` : `/cart`;
  url = showTaxes ? returnToCart ? `${url}?showTaxes=true&returnToCart=true` :
      `${url}?showTaxes=true` : returnToCart ? `${url}?returnToCart=true` : url;
  const response = await regenBasic.get(url);
  return response?.data;
};

//Get cart as per Sku
export const getCartBySku = async (sku) => {
  if (!sku) {
    return [];
  }
  const userId = getUserId() || deviceId;
  const url = userId ? `/cart/${userId}/${sku}` : `/cart/${sku}`;
  const response = await regenBasic.get(url);
  return response?.data;
};

export const updateCart = async (data) => {
  const userId = getUserId() || deviceId;
  const url = userId ? `/cart/${userId}` : `/cart`;
  const {admUserEmail, role} = parseJwt() || {};
  let dataWithAdmUserEmail = {
    ...data,
    admUserEmail: getHasImpersonate() && admUserEmail ? admUserEmail : "",
    admRole: getHasImpersonate() && role ? role : "",
  }
  const response = await regenBasic.put(url, dataWithAdmUserEmail);
  return response?.data;
};

export const deleteFromCart = async (data) => {
  const userId = getUserId() || deviceId;
  const url = userId ? `/cart/${userId}` : `/cart`;
  const response = await regenBasic.delete(url, data);
  return response?.data;
};

// Multi-coupon API functions
export const addCoupon = async (couponCode) => {
  const userId = getUserId() || deviceId;
  if (!userId) {
    throw new Error('User ID not found');
  }
  const url = `/cart/${userId}/coupon`;
  const response = await regenBasic.post(url, { couponCode });
  return response?.data;
};

export const removeCoupon = async (couponCode) => {
  const userId = getUserId() || deviceId;
  if (!userId) {
    throw new Error('User ID not found');
  }
  const url = `/cart/${userId}/coupon`;
  const response = await regenBasic.delete(url, { data: { couponCode } });
  return response?.data;
};

export const selectFreeItem = async (couponCode, selectedSku) => {
  const userId = getUserId() || deviceId;
  if (!userId) {
    throw new Error('User ID not found');
  }
  const url = `/cart/${userId}/coupon/freeitem`;
  const response = await regenBasic.put(url, { couponCode, selectedSku });
  return response?.data;
};

export const deselectFreeItem = async (couponCode) => {
  const userId = getUserId() || deviceId;
  if (!userId) {
    throw new Error('User ID not found');
  }
  const url = `/cart/${userId}/coupon/freeitem`;
  const response = await regenBasic.delete(url, { data: { couponCode } });
  return response?.data;
};
